import { BE_ADMIN_BASE } from "./environment";
import { apiGet, apiPost } from "./apiClient";

// FlightSuppliersMapping endpoints
export const getSupplierDetailsAPI = (opts) =>
  apiGet(`${BE_ADMIN_BASE}/suppliers/details`, opts);

export const updateSupplierAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/suppliers/update`, payload, opts);

export const updateAllSuppliersAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/suppliers/update-all`, payload, opts);

// SupplierConfiguration endpoints
export const getSupplierConfigurationsAPI = (opts) =>
  apiGet(`${BE_ADMIN_BASE}/suppliers/configurations`, opts);

export const viewSupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/suppliers/configurations/view`, payload, opts);

export const updateSupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/suppliers/configurations/update`, payload, opts);

export const saveSupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/suppliers/configurations/save`, payload, opts);

// Hotel Supplier Configuration endpoints
export const getHotelSupplierConfigurationsAPI = (opts) =>
  apiGet(`${BE_ADMIN_BASE}/hotel-suppliers/configurations`, opts);

export const viewHotelSupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/hotel-suppliers/configurations/view`, payload, opts);

export const updateHotelSupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/hotel-suppliers/configurations/update`, payload, opts);

export const saveHotelSupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/hotel-suppliers/configurations/save`, payload, opts);

export const toggleHotelSupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/hotel-suppliers/configurations/toggle`, payload, opts);

// Activity Supplier Configuration endpoints
export const getActivitySupplierConfigurationsAPI = (opts) =>
  apiGet(`${BE_ADMIN_BASE}/activity-suppliers/configurations`, opts);

export const viewActivitySupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/activity-suppliers/configurations/view`, payload, opts);

export const updateActivitySupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/activity-suppliers/configurations/update`, payload, opts);

export const saveActivitySupplierConfigurationAPI = (payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/activity-suppliers/configurations/save`, payload, opts);

// Service Fee Configuration endpoints (flight | hotel | activity)
export const getServiceFeeConfigurationsAPI = (product, opts) =>
  apiGet(`${BE_ADMIN_BASE}/servicefee-configurations/${product}`, opts);

export const viewServiceFeeConfigurationAPI = (product, payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/servicefee-configurations/${product}/view`, payload, opts);

export const updateServiceFeeConfigurationAPI = (product, payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/servicefee-configurations/${product}/update`, payload, opts);

export const saveServiceFeeConfigurationAPI = (product, payload, opts) =>
  apiPost(`${BE_ADMIN_BASE}/servicefee-configurations/${product}/save`, payload, opts);
